"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callExternalService = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
const jwt = __importStar(require("./jwt.util"));
const api_exception_1 = require("../exceptions/api.exception");
const callExternalService = ({ externalServiceUrl, signatureSecret }, { path, method, body, acceptableStatuses, region }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, node_fetch_1.default)(`${externalServiceUrl}${path}`, {
        method,
        body: JSON.stringify(body),
        headers: buildHttpHeaders(generateJwt(signatureSecret), region),
    });
    return yield validateResponse(response, acceptableStatuses);
});
exports.callExternalService = callExternalService;
const generateJwt = (secret) => {
    return jwt.sign({
        payload: {
            internalAuthOnly: true,
        },
        expiresIn: '12hr',
        secret,
    });
};
const buildHttpHeaders = (jwt, region) => {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Internal-Auth': jwt,
    };
    if (region) {
        headers['X-Waldo-Region'] = region;
    }
    return headers;
};
const validateResponse = (response, acceptableStatuses) => __awaiter(void 0, void 0, void 0, function* () {
    const json = yield response.json();
    if (acceptableStatuses.includes(response.status)) {
        return response.status == 404 ? undefined : json;
    }
    throw new api_exception_1.ApiException(json.error.message, {
        context: {
            destination: {
                internal: true,
            },
            response: {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers,
                body: json,
            },
        }
    });
});
